import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import "jspdf-autotable"; 
import tmplLogo from "../images/tmplLogo.png";
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import { Pagination } from "react-bootstrap";
import "./hm-theme.css";

function AppointmentReportsByTransactionDateForAdmin() {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [allAppDetails, setAllAppDetails] = useState([]);
  const [allAppNotTaken, setAllAppNotTaken] = useState([]);
  const [loader, setLoader] = useState(false); 
  const [fromDate, setFromDate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0); 
  const [toDate, setToDate] = useState(""); 
  const [status, setStatus] = useState([]); 
  const [appointmentType, setAppointmentType] = useState("all"); 
  const [appNotTakenData, setAppNotTakenData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [companyDetails, setCompanyDetails] = useState([]);
  const dateType="transactionDate";

  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;

  // Function to fetch data based on selected fromDate, toDate, and status
  const getData = async (pageNumber = 0) => {
    const options = {
      params: { page: pageNumber },
      headers: { Authorization: `Bearer ${token}` },
    };
  
    const reportUrl = `/api/appointmentReport/getPagedAppointmentsByDateRangeAndFiltersByRole`;

    const requestBody = {
      companyId: selectedCompany === "all" ? null : selectedCompany.id,
      fromDate: fromDate,
      toDate: toDate,
      appointmentStatus: status.length > 0 ? status : null,
      dateType: dateType,
      appointmentType: appointmentType === "all" ? null : appointmentType,
    };

    try {
      setLoader(true);
      const response = await axios.post(reportUrl, requestBody, options);
      setAppointmentDetails(response.data.empAppointments || []);
      setCurrentPage(response.data.currentPage || 0);
      setTotalPages(response.data.totalPages || 0);
      setAppNotTakenData([]);
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };
   
  const getAppNotTakenEmpData = async (pageNumber = 0) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const options = {
      params: { page: pageNumber },
      headers: { Authorization: `Bearer ${token}` },
    };
 
    try {
      setLoader(true); 
      const requestBody = {
        companyId: selectedCompany === "all" ? null : selectedCompany.id,
      };

      const response = await axios.post('/api/employeedetails/getPagedAppointmentsNotTakenEmployees', requestBody, options);
      setAppNotTakenData(response.data.content || []);
      setCurrentPage(response.data.number || 0);
      setTotalPages(response.data.totalPages || 0);
      setAppointmentDetails([]);
      setFromDate("");
      setToDate("");
      setStatus([]);
      setAppointmentType("all");
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };
     
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("data"))?.token;
        const orgcode = JSON.parse(localStorage.getItem("data"))?.orgcode;

        if (!token) return;

        if (userRole !== 'ROLE_EMPLOYER') {
          const companyRes = await axios.get("/api/companydetails/getCompanies", {
            headers: { Authorization: `Bearer ${token}` },
          });
          setCompanyDetails(companyRes.data || []);
        } else {
          const res = await axios.get(`/api/companydetails/companycode=${orgcode}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setSelectedCompany(res.data);
        }
      } catch (error) {
        handleError(error);
      }
    };

    fetchData();
  }, []);

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred.");
      }
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleGenerateReport = () => {
    if (fromDate && toDate) {
      getData(0);
    } else {
      toast.error("Please select both From Date and To Date.");
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };
  
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (appointmentDetails.length > 0) {
      getData(newPage);
    } else {
      getAppNotTakenEmpData(newPage);
    }
  };

  const handleAppNotTakenReport = () => {
    getAppNotTakenEmpData();
  };

  const [showDropdown, setShowDropdown] = useState(false);
  const [showNotTakenDropdown, setShowNotTakenDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const statusOptions = [
    "APPOINTMENT CONFIRMATION PENDING WITH LAB",
    "APPOINTMENT CONFIRMED",
    "APPOINTMENT RESCHEDULED",
    "APPOINTMENT COMPLETED",
    "APPOINTMENT CANCELLED"
  ];

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      if (status.includes("All")) {
        setStatus([]);
      } else {
        setStatus(statusOptions.slice(1));
      }
    } else {
      if (status.includes(value)) {
        setStatus(status.filter((item) => item !== value));
      } else {
        setStatus([...status, value]);
      }
    }
  };

  const handleDownloadReport = async (format) => {
    if (!fromDate && !toDate) {
      toast.error("Please select both From Date and To Date.");
      return;
    }

    const reportUrl = `/api/appointmentReport/getAllAppointmentsByDateRangeAndFiltersByRole`;
  
    const requestBody = {
      companyId: selectedCompany === "all" ? null : selectedCompany.id,
      fromDate: fromDate,
      toDate: toDate,
      appointmentStatus: status.length > 0 ? status : null,
      dateType: dateType,
      appointmentType: appointmentType === "all" ? null : appointmentType,
    };

    const options = {
      headers: { Authorization: `Bearer ${token}` },
    };
  
    try {
      setLoader(true);
      const response = await axios.post(reportUrl, requestBody, options);
      const appDetails = response.data.empAppointments;
      setAllAppDetails(response.data.empAppointments);
      
      if (response.data.empAppointments.length === 0) {
        setLoader(false);
        toast.error("No data available for the selected filters");
        return;
      }

      if (appNotTakenData.length > 0 || appDetails.length > 0) {
        if (format === "pdf") {
          const doc = new jsPDF("l", "mm", "a4");
          const logoWidth = 40;
          const logoHeight = 10;
          const titleFontSize = 16;
          const titleMargin = 10;

          doc.addImage(tmplLogo, "PNG", 10, 10, logoWidth, logoHeight);
          doc.setFontSize(titleFontSize);
          const pageWidth = doc.internal.pageSize.width;
          const titleText =
            appNotTakenData.length > 0
              ? "Appointment Not Taken Employees Report"
              : "Employees Appointment Report";
          const titleWidth =
            (doc.getStringUnitWidth(titleText) * titleFontSize) /
            doc.internal.scaleFactor;
          const titleX =
            (pageWidth - logoWidth - titleMargin - titleWidth) / 2 +
            logoWidth +
            titleMargin;

          doc.text(titleText, titleX, 20);
          doc.setFontSize(12);
          
          let startY = 30;
          let metaLine1 = '';
          let metaLine2 = '';
          
          if (selectedCompany) metaLine1 += `Company Code: ${selectedCompany.companycode}    `;
          if (appDetails.length > 0) metaLine1 += `From: ${fromDate}  To: ${toDate}    `;
          if (appointmentType) metaLine1 += `Appointment Type: ${appointmentType}`;
          
          if (Array.isArray(status) && status.length > 0) {
            metaLine2 += `Appointment Status: ${status.join(", ")}`;
          }
          
          if (metaLine1) {
            doc.text(metaLine1, 14, startY);
            startY += 10;
          }
          
          if (metaLine2) {
            doc.text(metaLine2, 14, startY);
            startY += 10;
          }
          
          const tableColumn = appNotTakenData.length > 0
            ? [
                "Sl No.",
                "Name",
                "Employee ID",
                "Email",
                "Phone Number",
                "Company Code",
              ]
            : [
                "Sl No.",
                "Name",
                "Transaction Date",
                "Appointment Date",
                "Package",
                "Employee ID",
                "Email",
                "Phone Number",
                "Company",
                "Lab",
                "Appointment Type",
                "Appointment Status",
              ];
          
          const tableRows = [];
          
          if (appNotTakenData.length > 0) {
            appNotTakenData.forEach((appointment, index) => {
              tableRows.push([
                index + 1,
                `${appointment.name} ${appointment.lastname}`,
                appointment.empid,
                appointment.email,
                appointment.phoneno,
                appointment.company?.companycode,
              ]);
            });
          } else {
            appDetails.forEach((appointment, index) => {
              tableRows.push([
                index + 1,
                appointment.fullName,
                appointment.transactionDate,
                appointment.appointmentDate,
                appointment.packageName,
                appointment.employeeId !== null ? appointment.employeeId : 'NA',
                appointment.email,
                appointment.phoneNumber,
                appointment.companyName,
                `${appointment.labName} (${appointment.labCode})`,
                appointment.appointmentType,
                appointment.appointmentStatus,
              ]);
            });
          }
          
          doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: startY + 10,
            margin: { top: 10, bottom: 30 },
            showHead: 'everyPage',
            theme: 'striped',
            styles: {
              fontSize: 8,
              cellPadding: 2,
              overflow: 'linebreak',
            },
            bodyStyles: {
              minCellHeight: 8,
            },
            didDrawPage: (data) => {
              const pageHeight = doc.internal.pageSize.height;
              doc.setFontSize(10);
              doc.setTextColor(128, 128, 128);
              doc.text(
                "This is a system-generated report and does not need a signature.",
                14,
                pageHeight - 20
              );
            },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            pageBreakBefore: () => false,
          });
          
          const pageCount = doc.internal.getNumberOfPages();
          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.text(
              `Page ${i} of ${pageCount}`,
              doc.internal.pageSize.width - 20,
              doc.internal.pageSize.height - 10,
              { align: 'right' }
            );
          }
          
          const fileName = `Appointment_Report_${fromDate || ""}_to_${toDate || ""}.pdf`;
          doc.save(fileName);
        } else if (format === "excel") {
          let wsData = [];
          wsData.push(
            appNotTakenData.length > 0
              ? [
                  "Sl No.",
                  "Name",
                  "Employee ID",
                  "Email",
                  "Phone Number",
                  "Company Code",
                ]
              : [
                  "Sl No.",
                  "Name",
                  "Transaction Date",
                  "Appointment Date",
                  "Package",
                  "Employee ID",
                  "Email",
                  "Phone Number",
                  "Company",
                  "Lab",
                  "Appointment Type",
                  "Appointment Status",
                ]
          );

          if (appNotTakenData.length > 0) {
            appNotTakenData.forEach((appointment, index) => {
              wsData.push([
                index + 1,
                `${appointment.name} ${appointment.lastname}`,
                appointment.empid,
                appointment.email,
                appointment.phoneno,
                appointment.company?.companycode,
              ]);
            });
          } else {
            appDetails.forEach((appointment, index) => {
              wsData.push([
                index + 1,
                appointment.fullName,
                appointment.transactionDate,
                appointment.appointmentDate,
                appointment.packageName,
                appointment.employeeId!==null?appointment.employeeId:'NA',
                appointment.email,
                appointment.phoneNumber,
                appointment.companyName,
                `${appointment.labName} (${appointment.labCode})`,
                appointment.appointmentType,
                appointment.appointmentStatus,
              ]);
            });
          }

          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(wsData);
          XLSX.utils.book_append_sheet(wb, ws, "Appointments");

          const fileName = `Appointment_Report_${fromDate || ""}_to_${toDate || ""}.xlsx`;
          const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const data = new Blob([excelBuffer], { type: "application/octet-stream" });
          saveAs(data, fileName);
        }
      } else {
        toast.error("No data available to generate report.");
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      toast.error("Failed to fetch report data");
    } finally {
      setLoader(false);
    }
  };

  const handleDownloadAppNotTakenEmpReport = async (format) => {
    const reportUrl = `/api/employeedetails/getAllAppointmentsNotTakenEmployees`;
    const requestBody = {
      companyId: selectedCompany === "all" ? null : selectedCompany.id,
    };
    const options = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      setLoader(true);
      const response = await axios.post(reportUrl, requestBody, options);
      const appNotTakenDetails = response.data;
      setAllAppNotTaken(response.data);
      
      if (appNotTakenDetails.length === 0) {
        setLoader(false);
        toast.error("No data available for the selected filters");
        return;
      }

      if (appNotTakenDetails.length > 0) {
        if (format === "pdf") {
          const doc = new jsPDF("l", "mm", "a4");
          const logoWidth = 40;
          const logoHeight = 10;
          const titleFontSize = 16;
          const titleMargin = 10;

          doc.addImage(tmplLogo, "PNG", 10, 10, logoWidth, logoHeight);
          doc.setFontSize(titleFontSize);
          const pageWidth = doc.internal.pageSize.width;
          const titleText = "Appointment Not Taken Employees Report";
          const titleWidth =
            (doc.getStringUnitWidth(titleText) * titleFontSize) /
            doc.internal.scaleFactor;
          const titleX =
            (pageWidth - logoWidth - titleMargin - titleWidth) / 2 +
            logoWidth +
            titleMargin;

          doc.text(titleText, titleX, 20);
          doc.setFontSize(12);
          let startY = 30;
          let metaLine1 = '';
        
          if (selectedCompany) metaLine1 += `Company Code: ${selectedCompany.companycode}    `;
          if (metaLine1) {
            doc.text(metaLine1, 14, startY);
            startY += 10;
          }
        
          const tableColumn = [
            "Sl No.",
            "Name",
            "Employee ID",
            "Email",
            "Phone Number",
            "Company Code",
          ];
           
          const tableRows = [];
          if (appNotTakenDetails.length > 0) {
            appNotTakenDetails.forEach((appointment, index) => {
              tableRows.push([
                index + 1,
                `${appointment.name} ${appointment.lastname}`,
                appointment.empid,
                appointment.email,
                appointment.phoneno,
                appointment.company?.companycode,
              ]);
            });
          }
          
          doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: startY + 10,
            margin: { top: 10, bottom: 30 },
            showHead: 'everyPage',
            theme: 'striped',
            styles: {
              fontSize: 10,
              cellPadding: 3,
              overflow: 'linebreak',
            },
            bodyStyles: {
              minCellHeight: 8,
            },
            didDrawPage: (data) => {
              const pageHeight = doc.internal.pageSize.height;
              doc.setFontSize(10);
              doc.setTextColor(128, 128, 128);
              doc.text(
                "This is a system-generated report and does not need a signature.",
                14,
                pageHeight - 20
              );
            },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            pageBreakBefore: () => false,
          });
          
          const pageCount = doc.internal.getNumberOfPages();
          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.text(
              `Page ${i} of ${pageCount}`,
              doc.internal.pageSize.width - 20,
              doc.internal.pageSize.height - 10,
              { align: 'right' }
            );
          }
          
          const fileName = `Appointment_Report_${fromDate || ""}_to_${toDate || ""}.pdf`;
          doc.save(fileName);
        } else if (format === "excel") {
          let wsData = [];
          wsData.push([
            "Sl No.",
            "Name",
            "Employee ID",
            "Email",
            "Phone Number",
            "Company Code",
          ]);

          if (appNotTakenDetails.length > 0) {
            appNotTakenDetails.forEach((appointment, index) => {
              wsData.push([
                index + 1,
                `${appointment.name} ${appointment.lastname}`,
                appointment.empid,
                appointment.email,
                appointment.phoneno,
                appointment.company?.companycode,
              ]);
            });
          }
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(wsData);
          XLSX.utils.book_append_sheet(wb, ws, "Appointments");

          const fileName = `Appointment_Report_${fromDate || ""}_to_${toDate || ""}.xlsx`;
          const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const data = new Blob([excelBuffer], { type: "application/octet-stream" });
          saveAs(data, fileName);
        }
      } else {
        toast.error("No data available to generate report.");
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      toast.error("Failed to fetch report data");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <Dashboard />
      {loader && <div className="loading"></div>}
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">event_note</i>
                Appointments Reports By Transaction Date
              </h2>
              <p className="hm-page-subtitle">
                Filter, generate, and export appointment reports by transaction date.
              </p>
            </div>
          </div>

          {/* Filter Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">filter_alt</i>
                Report Filters & Actions
              </h3>
            </div>
            <div className="hm-card-body p-3">
              <div className="row g-3">
                {userRole !== 'ROLE_EMPLOYER' && (
                  <div className="col-md-6 col-lg-3">
                    <label htmlFor="companyId" className="form-label small fw-semibold">Select Company</label>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        const selected = companyDetails.find(comp => comp.id === parseInt(e.target.value));
                        setSelectedCompany(selected || "all");
                      }}
                    >
                      <option value="all">All Companies</option>
                      {companyDetails.map((comp) => (
                        <option key={comp.id} value={comp.id}>
                          {comp.companyname}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="col-md-6 col-lg-2">
                  <label className="form-label small fw-semibold">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 col-lg-2">
                  <label className="form-label small fw-semibold">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 col-lg-3 position-relative">
                  <label className="form-label small fw-semibold">Appointment Status</label>
                  <div
                    className="form-select d-flex align-items-center justify-content-between text-truncate cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="text-truncate">
                      {status.length > 0 ? status.join(", ") : "Select Appointment Status"}
                    </span>
                    <i className="material-icons" style={{ fontSize: "1rem" }}>arrow_drop_down</i>
                  </div>
                  {isOpen && (
                    <div className="position-absolute start-0 end-0 bg-white border rounded shadow-sm p-2 mt-1 z-3" style={{ maxHeight: "200px", overflowY: "auto" }}>
                      {statusOptions.map((statusOption) => (
                        <div key={statusOption} className="form-check py-1">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`status-${statusOption}`}
                            value={statusOption}
                            checked={status.includes(statusOption)}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label small ms-1" htmlFor={`status-${statusOption}`}>
                            {statusOption}
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="col-md-6 col-lg-2">
                  <label className="form-label small fw-semibold">Appointment Type</label>
                  <select
                    className="form-select"
                    value={appointmentType}
                    onChange={(e) => setAppointmentType(e.target.value)}
                  >
                    <option value="all">ALL</option>
                    <option value="ahc">AHC</option>
                    <option value="peme">PEME</option>
                  </select>
                </div>
              </div>

              {/* Action Buttons Bar */}
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 pt-3 border-top mt-3">
                {/* Left Section */}
                <div className="d-flex align-items-center gap-2">
                  <button className="btn btn-outline-secondary rounded-pill px-3" onClick={handleAppNotTakenReport}>
                    Appointment Not Taken
                  </button>
                  <div className="dropdown position-relative">
                    <button
                      className="btn btn-outline-primary rounded-pill px-3 dropdown-toggle"
                      onClick={() => setShowNotTakenDropdown(!showNotTakenDropdown)}
                    >
                      <i className="material-icons me-1" style={{ fontSize: "1rem" }}>download</i>
                      Download Report
                    </button>
                    {showNotTakenDropdown && (
                      <ul className="dropdown-menu show position-absolute mt-1 shadow-sm">
                        <li>
                          <button className="dropdown-item" onClick={() => { setShowNotTakenDropdown(false); handleDownloadAppNotTakenEmpReport('pdf'); }}>
                            PDF Format
                          </button>
                        </li>
                        <li>
                          <button className="dropdown-item" onClick={() => { setShowNotTakenDropdown(false); handleDownloadAppNotTakenEmpReport('excel'); }}>
                            Excel Format
                          </button>
                        </li>
                      </ul>
                    )}
                  </div>
                </div>

                {/* Right Section */}
                <div className="d-flex align-items-center gap-2">
                  <button className="btn-hm-primary px-4" onClick={handleGenerateReport}>
                    <i className="material-icons me-1" style={{ fontSize: "1rem" }}>play_arrow</i>
                    Generate Report
                  </button>
                  <div className="dropdown position-relative">
                    <button
                      className="btn-hm-primary px-3 dropdown-toggle"
                      onClick={() => setShowDropdown(!showDropdown)}
                    >
                      <i className="material-icons me-1" style={{ fontSize: "1rem" }}>download</i>
                      Download Report
                    </button>
                    {showDropdown && (
                      <ul className="dropdown-menu show position-absolute mt-1 shadow-sm end-0">
                        <li>
                          <button className="dropdown-item" onClick={() => { setShowDropdown(false); handleDownloadReport('pdf'); }}>
                            PDF Format
                          </button>
                        </li>
                        <li>
                          <button className="dropdown-item" onClick={() => { setShowDropdown(false); handleDownloadReport('excel'); }}>
                            Excel Format
                          </button>
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Results Table Card */}
          <div className="hm-card">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">assessment</i>
                {appNotTakenData.length > 0 ? "Appointment Not Taken Employees" : "Appointment Taken Employees"}
              </h3>
            </div>
            <div className="hm-card-body p-0">
              {appointmentDetails.length === 0 && appNotTakenData.length === 0 && (
                <div className="hm-empty-state py-5">
                  <i className="material-icons">assessment</i>
                  <p>{loader ? "Generating report..." : "No Data Available"}</p>
                </div>
              )}

              {appNotTakenData.length === 0 && appointmentDetails.length > 0 && (
                <>
                  <div style={{ overflowX: "auto" }}>
                    <table className="hm-table">
                      <thead>
                        <tr>
                          <th>Sl.No.</th>
                          <th>Name</th>
                          <th>Transaction Date</th>
                          <th>Appointment Date</th>
                          <th>Package</th>
                          <th>Employee ID</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>Company</th>
                          <th>Lab</th>     
                          <th>Type</th>          
                          <th className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appointmentDetails.map((appointment, index) => (
                          <tr key={appointment.id || index}>
                            <td>{currentPage * 10 + index + 1}</td>
                            <td className="fw-semibold">{appointment.fullName}</td>
                            <td>{appointment.transactionDate}</td>
                            <td>{appointment.appointmentDate}</td>
                            <td>{appointment.packageName}</td>
                            <td>{appointment.employeeId !== null ? appointment.employeeId : 'NA'}</td>
                            <td>{appointment.email}</td>
                            <td>{appointment.phoneNumber}</td>
                            <td>{appointment.companyName}</td>
                            <td>{appointment.labName}</td>
                            <td>
                              <span className="hm-badge hm-badge-info">
                                {appointment.appointmentType}
                              </span>
                            </td>
                            <td className="text-center">
                              <span className={`hm-badge ${
                                appointment.appointmentStatus?.includes("COMPLETED")
                                  ? "hm-badge-success"
                                  : appointment.appointmentStatus?.includes("CONFIRMED")
                                  ? "hm-badge-info"
                                  : appointment.appointmentStatus?.includes("CANCELLED")
                                  ? "hm-badge-danger"
                                  : "hm-badge-warning"
                              }`}>
                                {appointment.appointmentStatus}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {totalPages > 1 && (
                    <div className="hm-pagination p-3 border-top d-flex justify-content-center">
                      <Pagination className="mb-0">
                        <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                        {renderPageNumbers()}
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                        <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                      </Pagination>
                    </div>
                  )}
                </>
              )}

              {appNotTakenData.length > 0 && (
                <>
                  <div style={{ overflowX: "auto" }}>
                    <table className="hm-table">
                      <thead>
                        <tr>
                          <th>Sl.No.</th>
                          <th>Name</th>
                          <th>Employee ID</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>Company Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appNotTakenData.map((employee, index) => (
                          <tr key={employee.id || index}>
                            <td>{currentPage * 10 + index + 1}</td>
                            <td className="fw-semibold">
                              {employee.name} {employee.lastname}
                            </td>
                            <td>{employee.empid}</td>
                            <td>{employee.email}</td>
                            <td>{employee.phoneno}</td>
                            <td>{employee.company?.companycode}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {totalPages > 1 && (
                    <div className="hm-pagination p-3 border-top d-flex justify-content-center">
                      <Pagination className="mb-0">
                        <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                        {renderPageNumbers()}
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                        <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                      </Pagination>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppointmentReportsByTransactionDateForAdmin;


